export default {
  init($element) {

  },
  finalize($element) {
    // Company logos
    const $logosWrap = $element.find('.logos-wrap');

    $logosWrap.find('.logo-column').each(function(i) {

      const $this_ = $(this);

      setInterval(() => {

        setTimeout(() => {

          const $currentItem = $this_.find('.logo-item.show');

          // Set current 'show' to 'hiding'
          $currentItem.addClass('hiding');
          
          setTimeout(() => {
            var $nextItem = $currentItem.next();

            if ($nextItem.length == 0) {
              $nextItem = $($currentItem.siblings()[0]);
            }

            // Get the next item and show it
            $nextItem.addClass('show');
          }, 100);

          // Wait until the current item has finished hiding and remove all classes
          setTimeout(() => {
            $currentItem.removeClass('hiding show');
            
          }, 900);

        }, (300 * i));

      }, 3000);

    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/landing/introLogos.js